const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  year: 'numeric',
  day: 'numeric',
};

export function formatDate(date?: Date | string) {
  if (!date) {
    return '';
  }
  if (date instanceof Date) {
    return date.toLocaleDateString('en-IN', DATE_FORMAT_OPTIONS);
  }
  const parsedDate = new Date(date);
  if (parsedDate.toString() === 'Invalid Date') {
    return '';
  }
  return formatDate(parsedDate);
}
